import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./styles/sidebar.module.scss";
import { NavBarOptions } from "../utils/helpers/data/navbar";
import { IoMdLogOut } from "react-icons/io";
import axios from "axios";
import config from "../config";
import { userContext } from "../context/user";

const SideBarContent = () => {
  const navOptions = NavBarOptions();
  const navigate = useNavigate();
  const location = useLocation();

  const { userDetails, setUserDetails } = useContext(userContext);

  const LogOut = async () => {
    const response = await axios.get(`${config.apiUrl}/da/logout`, {
      withCredentials: true,
    });

    console.log(response);
    setUserDetails(response.data);
    localStorage.removeItem("/dashboard");
    localStorage.removeItem("/dashboard/manage");
    localStorage.removeItem(location.pathname);
    // console.log(userDetails);
    navigate("/");
  };

  console.log(userDetails);

  return (
    <div className={styles.sideBarContent}>
      <div className={`${styles.logoArea}`}>
        <div className={`${styles.logoBox}`}>
          <img
            src="../../assets/logo.png"
            style={{ objectFit: "contain" }}
            alt="logo"
            width={125}
          />
        </div>
      </div>
      <hr
        className="mt-4"
        style={{
          border: "1px solid rgba(42, 55, 138, 0.75)",
          color: "rgba(42, 55, 138, 0.75)",
        }}
      />
      <div className={styles.navBarOptions}>
        {navOptions.map((item, i) => (
          <div key={i} className={styles.listsBox}>
            <Link
              style={{
                color: "rgba(42, 55, 138, 0.75)",
                textDecoration: "none",
              }}
              to={item.target}
            >
              <span
                className={`mr-2 ${styles.itemIcon}`}
                style={{ color: "rgba(42, 55, 138, 0.75)" }}
              >
                {item.icon}
              </span>
              {item.label}
            </Link>
          </div>
        ))}
      </div>
      <div className={styles.footer}>
        <hr
          style={{
            border: "1px solid rgba(42, 55, 138, 0.75)",
            color: "rgba(42, 55, 138, 0.75)",
            minWidth: "120px",
          }}
        />
        <div onClick={LogOut}>
          <IoMdLogOut size={25} />
          <span
            className="ml-4"
            style={{ fontWeight: "600", cursor: "pointer" }}
          >
            Logout
          </span>
        </div>
      </div>
    </div>
  );
};

export default SideBarContent;
